import { render, staticRenderFns } from "./DetailOrder.vue?vue&type=template&id=4e63b9db&scoped=true"
import script from "./DetailOrder.vue?vue&type=script&lang=js"
export * from "./DetailOrder.vue?vue&type=script&lang=js"
import style0 from "./DetailOrder.vue?vue&type=style&index=0&id=4e63b9db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e63b9db",
  null
  
)

export default component.exports